import {store} from './global-store';

export const authActions = {
    setRefreshInternalAuthTokenUrl(url) {
        store.commit('setRefreshInternalAuthTokenUrl', url);
    },
};
